"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchWithSpuScene = exports.useFetchWithSpuCode = exports.useFetch = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
function useFetch(fetcher, defaultValue) {
    const subject = (0, react_1.useMemo)(() => new rxjs_1.BehaviorSubject(defaultValue), [defaultValue]);
    (0, react_1.useEffect)(() => {
        fetcher()
            .then(nextValue => {
            if (nextValue) {
                subject.next(nextValue);
            }
        })
            .catch(error => subject.error(error));
    }, [fetcher, subject]);
    return subject;
}
exports.useFetch = useFetch;
function useFetchWithSpuCode(spuCode, fetcher, defaultValue) {
    const realFetcher = (0, react_1.useCallback)(() => (spuCode ? fetcher(spuCode) : Promise.resolve(undefined)), [fetcher, spuCode]);
    return useFetch(realFetcher, defaultValue);
}
exports.useFetchWithSpuCode = useFetchWithSpuCode;
function useFetchWithSpuScene(spuCode, scene, fetcher, defaultValue) {
    const realFetcher = (0, react_1.useCallback)(() => (spuCode ? fetcher(spuCode, scene) : Promise.resolve(undefined)), [fetcher, spuCode, scene]);
    return useFetch(realFetcher, defaultValue);
}
exports.useFetchWithSpuScene = useFetchWithSpuScene;
